// extracted by mini-css-extract-plugin
export default {"image":"_image_image__fsNk8","image__loaded":"_image_image__loaded__6YEeH"};